import _extends from "@babel/runtime/helpers/esm/extends";
export var getPickersLocalization = function getPickersLocalization(pickersTranslations) {
  return {
    components: {
      MuiLocalizationProvider: {
        defaultProps: {
          localeText: _extends({}, pickersTranslations)
        }
      }
    }
  };
};
export var buildGetOpenDialogAriaText = function buildGetOpenDialogAriaText(params) {
  var utils = params.utils,
    formatKey = params.formatKey,
    contextTranslation = params.contextTranslation,
    propsTranslation = params.propsTranslation;
  return function (value) {
    var formattedValue = value !== null && utils.isValid(value) ? utils.format(value, formatKey) : null;
    var translation = propsTranslation !== null && propsTranslation !== void 0 ? propsTranslation : contextTranslation;
    return translation(value, utils, formattedValue);
  };
};